module.exports = __webpack_public_path__ + "static/logo.kdc-10cc4b0a454721b70c9d0acfbfc3fe22.svg";